import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c792c216"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, " 该股自" + _toDisplayString(_ctx.DividendSituationSummaryData.date) + "上市以来，累计分红送转" + _toDisplayString(_ctx.DividendSituationSummaryData.DividendTimes) + "次，累次分红金额" + _toDisplayString(_ctx.DividendSituationSummaryData.total) + "元 ", 1),
            _createVNode(_component_Charts, {
              id: "NumberofShareholders",
              option: _ctx.option
            }, null, 8, ["option"]),
            _createVNode(_component_Table, {
              data: _ctx.data,
              columns: _ctx.columns,
              bordered: true,
              pagination: false
            }, null, 8, ["data", "columns"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(_component_Nodata, { nodatadesc: '分红' })
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}